// German translations
const de = {
  cover: {
    title: "Schachkönigreich",
    subtitle: "Der Königshof",
    riseOfDukes: "Aufstieg der Herzöge",
    enter: "EINTRETEN",
    aboutUs: "ÜBER UNS",
    tagline: "Wo Legenden entstehen und jeder Zug eine Geschichte erzählt",
    selectLanguage: "Sprache Wählen"
  },
  auth: {
    login: "Anmelden",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    username: "Benutzername",
    forgotPassword: "Passwort vergessen?",
    noAccount: "Noch kein Konto?",
    hasAccount: "Bereits ein Konto?",
    signUp: "Registrieren",
    signIn: "Anmelden",
    orContinueWith: "Oder fortfahren mit",
    guest: "Als Gast spielen",
    logout: "Abmelden"
  },
  lobby: {
    title: "LOBBY",
    subtitleRise: "Aufstieg der",
    subtitleDukes: "Herzöge",
    quickPlay: "SCHNELLSPIEL",
    createRoom: "RAUM ERSTELLEN",
    joinRoom: "BEITRETEN",
    settings: "Einstellungen",
    skins: "SKINS",
    friends: "Freunde",
    chat: "Chat",
    spectate: "ZUSCHAUEN",
    roomCode: "Raumcode",
    enterRoomCode: "Code eingeben...",
    join: "Beitreten",
    create: "Erstellen",
    private: "Privat",
    public: "Öffentlich",
    players: "Spieler",
    waiting: "Warte auf Gegner...",
    ready: "Bereit",
    start: "Starten",
    gameSetup: "SPIELEINSTELLUNG",
    chooseVariant: "Variante und Modus wählen",
    multiplayer: "MEHRSPIELER",
    onlineMatches: "Online-Spiele",
    profile: "Profil",
    messages: "Nachrichten",
    assistant: "Assistent",
    help: "Hilfe",
    exit: "Beenden"
  },
  game: {
    white: "Weiß",
    black: "Schwarz",
    whiteToMove: "Weiß am Zug",
    blackToMove: "Schwarz am Zug",
    check: "Schach!",
    checkmate: "Schachmatt!",
    stalemate: "Patt!",
    draw: "Remis",
    resign: "Aufgeben",
    resigns: "Gibt auf",
    forfeits: "Verliert kampflos",
    offerDraw: "Remis anbieten",
    acceptDraw: "Remis annehmen",
    declineDraw: "Remis ablehnen",
    newGame: "Neues Spiel",
    leave: "Verlassen",
    rules: "REGELN",
    moveHistory: "Zughistorie",
    noMovesYet: "Noch keine Züge",
    movesWillAppear: "Züge erscheinen hier",
    yourTurn: "Dein Zug",
    opponentTurn: "Gegner am Zug",
    gameOver: "Spiel Beendet",
    youWin: "DU GEWINNST!",
    youLose: "Du hast verloren",
    whiteWins: "Weiß gewinnt!",
    blackWins: "Schwarz gewinnt!",
    drawGame: "Unentschieden!",
    playAgain: "Nochmal spielen",
    backToLobby: "Zurück zur Lobby",
    classic: "KLASSISCH",
    kingsCourt: "KÖNIGSHOF",
    fightToBeKing: "Kampf um den Thron",
    kingCaptured: "König geschlagen!",
    winner: "Gewinner",
    rematch: "Revanche",
    decline: "Ablehnen",
    waiting: "Warte...",
    acceptRematch: "Revanche annehmen",
    wantsRematch: "möchte eine Revanche!",
    rematchAccepted: "Revanche angenommen! Neues Spiel...",
    rematchDeclined: "Revanche abgelehnt. Zurück zur Lobby...",
    waitingForOpponent: "Warte auf Gegner...",
    startingNewGame: "Starte neues Spiel...",
    continue: "Weiter"
  },
  settings: {
    title: "Einstellungen",
    boardCustomization: "Brett- und Figurengestaltung",
    livePreview: "Live-Vorschau",
    previewDescription: "Deine Anpassungen sehen",
    boardTheme: "Brettfarben",
    pieceTheme: "Figurenfarben",
    customColors: "Eigene Farben",
    presetThemes: "Voreingestellte Themen",
    lightSquares: "Helle Felder",
    darkSquares: "Dunkle Felder",
    whitePieces: "Weiße Figuren",
    blackPieces: "Schwarze Figuren",
    coordinateColor: "Koordinatenfarbe",
    coordinateDescription: "Farbe der Zahlen (1-8) und Buchstaben (a-h)",
    chessPieceSkins: "Figuren-Skins",
    chessPieceSkinsDescription: "Standardfiguren durch Premium 3D-Skins ersetzen",
    dukeSkins: "Herzog-Skins",
    dukeSkinsDescription: "Herzog-Skins wählen - Brettfarben passen sich an!",
    whiteSideDuke: "Weißer Herzog",
    blackSideDuke: "Schwarzer Herzog",
    autoMatchBoard: "Brettfarben automatisch anpassen",
    saveAndClose: "Speichern & Schließen",
    reset: "Zurücksetzen",
    close: "Schließen",
    premium: "Premium",
    default: "Standard",
    classic: "Klassisch",
    viewMode: "Ansichtsmodus",
    viewModeDescription: "Schachbrett-Ansicht wählen",
    topDown: "Draufsicht",
    topDownDescription: "Flache Ansicht wie traditionelle Bretter",
    perspective3D: "3D-Perspektive",
    perspective3DDescription: "2D-Figuren mit dynamischem 3D-Winkel",
    skinsApplyTo: "Skins für König, Dame, Turm, Läufer, Springer, Bauer",
    dukeHint: "Links: Sofort-König · Rechts: Kampf um den Thron"
  },
  store: {
    title: "Skin-Shop",
    subtitle: "King's Court",
    riseOfDukes: "Rise of the Dukes",
    chessPieces: "Schachfiguren",
    dukeSkins: "Herzog-Skins",
    allPiecesBundle: "Alle Figuren-Skins Paket",
    allDukeBundle: "Alle Herzog-Skins Paket",
    bundleDiscount: "Alle Premium-Skins mit 30% Rabatt!",
    owned: "Besitz",
    equip: "Ausrüsten",
    buy: "Kaufen",
    processing: "Verarbeitung...",
    free: "Kostenlos",
    rare: "selten",
    epic: "episch",
    legendary: "legendär",
    common: "gewöhnlich",
    securePayment: "Einmalkauf • Für immer nutzen • Sichere Zahlung"
  },
  chat: {
    title: "Chat",
    lobbyChat: "Lobby-Chat",
    gameChat: "Spiel-Chat",
    typeMessage: "Nachricht eingeben...",
    send: "Senden",
    spectatorChat: "Zuschauer-Chat",
    playerChat: "Spieler-Chat"
  },
  friends: {
    title: "Freunde",
    online: "Online",
    offline: "Offline",
    addFriend: "Freund hinzufügen",
    removeFriend: "Entfernen",
    invite: "Einladen",
    pending: "Ausstehend",
    accept: "Annehmen",
    decline: "Ablehnen",
    friendRequests: "Freundschaftsanfragen",
    noFriends: "Noch keine Freunde",
    searchPlayers: "Spieler suchen..."
  },
  notifications: {
    friendRequest: "hat dir eine Freundschaftsanfrage geschickt",
    gameInvite: "lädt dich zum Spielen ein",
    yourTurn: "Du bist am Zug!",
    opponentJoined: "Gegner ist beigetreten",
    opponentLeft: "Gegner hat verlassen",
    drawOffered: "Gegner bietet Remis an",
    connected: "Mit Server verbunden",
    disconnected: "Vom Server getrennt",
    reconnecting: "Verbinde neu..."
  },
  errors: {
    invalidEmail: "Ungültige E-Mail-Adresse",
    invalidPassword: "Passwort muss mindestens 6 Zeichen haben",
    passwordMismatch: "Passwörter stimmen nicht überein",
    loginFailed: "Anmeldung fehlgeschlagen. Prüfe deine Daten.",
    registerFailed: "Registrierung fehlgeschlagen. Versuche es erneut.",
    connectionError: "Verbindungsfehler. Versuche es erneut.",
    connectionErrorInternet: "Verbindungsfehler. Prüfe dein Internet.",
    gameNotFound: "Spiel nicht gefunden",
    roomFull: "Raum ist voll",
    invalidMove: "Ungültiger Zug",
    pleaseEnterName: "Bitte gib deinen Namen ein",
    completeBothSecurityQuestions: "Beide Sicherheitsfragen ausfüllen oder leer lassen",
    selectDifferentQuestions: "Bitte wähle verschiedene Fragen",
    unexpectedError: "Ein unerwarteter Fehler ist aufgetreten",
    failedToSendResetCode: "Fehler beim Senden des Zurücksetzungscodes",
    invalidOrExpiredCode: "Ungültiger oder abgelaufener Code",
    failedToResetPassword: "Fehler beim Zurücksetzen. Versuche es erneut.",
    pleaseEnterRoomName: "Bitte gib einen Raumnamen ein",
    pleaseEnterRoomCode: "Bitte gib einen Raumcode ein",
    roomCodeMustBe6Chars: "Code muss 6 Zeichen haben",
    roomNotFound: "Raum nicht gefunden. Prüfe den Code.",
    roomRequiresApproval: "Dieser Raum erfordert Genehmigung. Bitte anfragen.",
    failedToCreateRoom: "Fehler beim Erstellen des Raums",
    failedToJoinRoom: "Fehler beim Beitreten",
    failedToLeaveRoom: "Fehler beim Verlassen",
    failedToRemoveRoom: "Fehler beim Entfernen des Raums",
    failedToLoadGames: "Fehler beim Laden der Spiele",
    failedToRequestRejoin: "Fehler bei der Wiederanmeldung",
    failedToJoinMatchmaking: "Fehler beim Matchmaking",
    noOpponentFound: "Kein Gegner gefunden. Später erneut versuchen.",
    searchFailed: "Suche fehlgeschlagen",
    failedToSendRequest: "Fehler beim Senden der Anfrage",
    failedToAcceptRequest: "Fehler beim Akzeptieren",
    failedToRejectRequest: "Fehler beim Ablehnen",
    failedToCancelRequest: "Fehler beim Abbrechen",
    failedToRemoveFriend: "Fehler beim Entfernen des Freundes"
  },
  success: {
    copiedToClipboard: "In Zwischenablage kopiert!",
    rejoinRequestSent: "Anfrage an Host gesendet!",
    roomRemovedFromList: "Raum aus Liste entfernt.",
    leftRoomSuccessfully: "Raum erfolgreich verlassen",
    requestRejected: "Anfrage abgelehnt",
    requestCancelled: "Anfrage abgebrochen",
    friendRemoved: "Freund entfernt",
    tournamentCreated: "Turnier erfolgreich erstellt!",
    tournamentJoined: "Turnier erfolgreich beigetreten!",
    tournamentLeft: "Turnier verlassen",
    tournamentStarted: "Turnier gestartet!",
    tournamentCancelled: "Turnier abgebrochen",
    tournamentsCleared: "Alle Turniere gelöscht",
    removedFromHistory: "Aus Verlauf entfernt"
  },
  tournament: {
    title: "Turniere",
    createTournament: "Turnier Erstellen",
    joinTournament: "Turnier Beitreten",
    leaveTournament: "Turnier Verlassen",
    startTournament: "Turnier Starten",
    cancelTournament: "Turnier Abbrechen",
    clearAll: "Alle Löschen",
    myTournaments: "Meine Turniere",
    availableTournaments: "Verfügbare Turniere",
    tournamentHistory: "Turnierverlauf",
    bracket: "Turnierbaum",
    participants: "Teilnehmer",
    status: "Status",
    waiting: "Wartend",
    inProgress: "Läuft",
    completed: "Abgeschlossen",
    cancelled: "Abgebrochen",
    format: "Format",
    singleElimination: "Einfache K.O.",
    doubleElimination: "Doppelte K.O.",
    swiss: "Schweizer System",
    round: "Runde",
    match: "Partie",
    ready: "Bereit",
    notReady: "Nicht Bereit",
    markReady: "Bereit Markieren",
    winner: "Gewinner",
    loser: "Verlierer",
    bye: "Freilos",
    pleaseLoginToCreate: "Anmelden um Turnier zu erstellen",
    pleaseLoginToJoin: "Anmelden um beizutreten",
    failedToLoadTournaments: "Fehler beim Laden der Turniere",
    failedToCreateTournament: "Fehler beim Erstellen des Turniers",
    failedToJoinTournament: "Fehler beim Beitreten des Turniers",
    failedToLeaveTournament: "Fehler beim Verlassen des Turniers",
    failedToStartTournament: "Fehler beim Starten des Turniers",
    failedToCancelTournament: "Fehler beim Abbrechen des Turniers",
    failedToClearTournaments: "Fehler beim Löschen der Turniere",
    failedToRemoveFromHistory: "Fehler beim Entfernen aus Verlauf",
    failedToLoadTournament: "Fehler beim Laden des Turniers",
    failedToMarkReady: "Fehler beim Bereit-Markieren"
  },
  ranked: {
    title: "Rangliste",
    findMatch: "Ranglistenspiel Finden",
    inQueue: "In Warteschlange...",
    leaveQueue: "Warteschlange Verlassen",
    yourRank: "Dein Rang",
    elo: "ELO",
    tier: "Stufe",
    wins: "Siege",
    losses: "Niederlagen",
    draws: "Unentschieden",
    season: "Saison",
    leaderboard: "Bestenliste",
    squire: "Knappe",
    knight: "Ritter",
    baron: "Baron",
    duke: "Herzog",
    king: "König",
    pleaseLoginToPlay: "Anmelden für Ranglistenspiele",
    failedToJoinQueue: "Fehler beim Beitreten der Warteschlange"
  },
  misc: {
    loading: "Laden...",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    yes: "Ja",
    no: "Nein",
    ok: "OK",
    save: "Speichern",
    delete: "Löschen",
    edit: "Bearbeiten",
    back: "Zurück",
    next: "Weiter",
    previous: "Zurück",
    search: "Suchen",
    filter: "Filtern",
    sort: "Sortieren",
    all: "Alle",
    none: "Keine",
    select: "Auswählen",
    selected: "Ausgewählt"
  },
  
  // About Us Page
  aboutUs: {
    back: "← Zurück",
    title: "Willkommen bei Chess Kingdom: King's Court",
    subtitle: "King's Court",
    riseOfDukes: "Rise of the Dukes",
    description: "Betritt ein Reich, in dem klassische Strategie auf mythische Dimensionen trifft. King's Court ist mehr als ein Spielmodus – es ist ein Prüffeld für Taktiker, Träumer und Champions. Ob du ein Großmeister auf der Suche nach neuen Herausforderungen oder ein Neuling bist, der den Nervenkitzel der Eroberung sucht, hier ist deine Arena. ⚔️",
    keyFeatures: "Hauptmerkmale",
    feature1Title: "Dynamische Varianten",
    feature1Desc: "Erkunde sich entwickelnde Regelwerke und Brettlayouts, die deine Anpassungsfähigkeit und Voraussicht testen.",
    feature2Title: "Höfischer Aufstieg",
    feature2Desc: "Verdiene Titel, schalte Embleme frei und steige durch ein reichhaltiges Rangsystem auf, das Meisterschaft und Stil belohnt.",
    feature3Title: "Skill-basiertes Spiel",
    feature3Desc: "Transparentes Feedback, telemetrisch abgestimmte Balance und faires Matchmaking sorgen dafür, dass jeder Sieg verdient ist.",
    feature4Title: "Live-Chat & Lore-Threads",
    feature4Desc: "Verbinde dich mit Rivalen und Verbündeten, entdecke prozedural generierte Geschichten und forme die Mythologie deines Königreichs.",
    feature5Title: "Für Profis gebaut",
    feature5Desc: "Präzisionstuning, Replay-Analyse und turnierfertige Infrastruktur machen King's Court zu einer ernsthaften Plattform für kompetitives Spielen.",
    closingStatement: "Ob du Ruhm, Wachstum oder große Strategie suchst, King's Court lädt dich ein, mit Weisheit zu herrschen, mit Ehre zu kämpfen und deine Spuren im Reich zu hinterlassen.",
    developmentNotice: "Hinweis: Das Spiel befindet sich noch in Entwicklung, und mit deiner Geduld und Unterstützung wird es zu einem Zuhause fern der Heimat. Hab Spaß, finde Freunde und Allianzen, denn wenn ich fertig bin, werden deine strategischen Siegmethoden auf die Probe gestellt... Willkommen in deinem Königreich...",
    contactTitle: "Mehr Info oder Vorschläge Kontakt:",
    contactEmail: "CKKC.customerservice@gmail.com"
  },
  
  // Store
  store: {
    title: "Skin-Shop",
    themedSets: "Themen-Sets",
    pieceSkins: "Figuren-Skins",
    dukeSkins: "Herzog-Skins",
    unlockSet: "Set Freischalten",
    owned: "Besitzt",
    price: "Preis",
    checkout: "Zur Kasse",
    addToCart: "In den Warenkorb",
    cart: "Warenkorb",
    total: "Gesamt",
    continueShopping: "Weiter Einkaufen",
    proceedToCheckout: "Zur Kasse gehen",
    emptyCart: "Dein Warenkorb ist leer",
    itemAdded: "Artikel zum Warenkorb hinzugefügt",
    purchaseSuccess: "Kauf erfolgreich!",
    purchaseFailed: "Kauf fehlgeschlagen. Bitte erneut versuchen."
  },
  
  // Rules
  rules: {
    title: "Spielregeln",
    classic: "Klassisches Schach",
    classicDesc: "Standard-Schachregeln - setze den gegnerischen König schachmatt, um zu gewinnen.",
    instantKing: "Instant King",
    instantKingDesc: "Schlage den feindlichen König direkt, um zu gewinnen - kein Schachmatt nötig!",
    fightToBeKing: "Kampf um die Krone",
    fightToBeKingDesc: "Dein umgewandelter Bauer wird zum neuen König! Beschütze ihn oder verliere das Spiel.",
    timerRules: "Timer-Regeln",
    timerDesc: "Jeder Spieler hat begrenzte Zeit pro Zug. Läuft die Zeit ab, wird dein Zug übersprungen."
  },
  
  // Assistant
  assistant: {
    title: "Chess Kingdom Assistent",
    searchPlaceholder: "Hilfethemen suchen...",
    randomTip: "Zeige einen zufälligen Tipp",
    noResults: "Keine Hilfethemen gefunden für",
    noResultsHint: "Versuche andere Schlüsselwörter oder durchsuche die Kategorien oben",
    categories: {
      gettingStarted: "Erste Schritte",
      dukeMechanics: "Herzog-Mechaniken",
      multiplayer: "Mehrspieler",
      customization: "Anpassung",
      boardFeatures: "Brett-Funktionen",
      skinStore: "Skin-Shop",
      trialPayments: "Test & Zahlungen",
      strategyTips: "Strategie",
      troubleshooting: "Fehlerbehebung"
    },
    gettingStarted: {
      q1: "Wie fange ich an zu spielen?",
      a1: "Klicke auf 'Solo-Spiel' um gegen KI zu spielen, oder 'Mehrspieler' um mit anderen zu spielen. Du kannst als Gast spielen oder dich für eine kostenlose 48-Stunden-Testversion anmelden.",
      q2: "Was sind die verschiedenen Spielvarianten?",
      a2: "Chess Kingdom bietet 7 Varianten: Standard-Schach, Instant King, Kampf um die Krone, Spielerwahl, Wilde Bauern, Chess Kingdom (Zwei Herzöge) und Handicap-Modus.",
      q3: "Wie passe ich das Brett an?",
      a3: "Klicke auf Einstellungen für Anpassungsoptionen. Du kannst Brettfarben, Figuren-Skins, Herzog-Skins, Themen, Koordinatenfarbe, Ansichtsmodus und Brettgröße ändern.",
      q4: "Wie drehe ich die Brettansicht?",
      a4: "Klicke auf den Drehen-Button im Spielkopf, um das Brett aus der Perspektive von Schwarz zu sehen.",
      q5: "Wie ändere ich die Brettgröße?",
      a5: "Gehe zu Einstellungen → Brettgröße. Nutze den Schieberegler oder klicke auf 'Kompakt' (85%), 'Standard' (100%) oder 'Groß' (115%)."
    },
    dukeMechanics: {
      q1: "Was ist die Herzog-Figur?",
      a1: "Der Herzog ist eine spezielle Figur, die einen Läufer ersetzt. Er bewegt sich diagonal (1 Feld) für nicht-schlagende Züge, kann aber in alle 8 Richtungen schlagen (nur benachbarte Felder).",
      q2: "Was passiert, wenn mein König geschlagen wird?",
      a2: "Dein Herzog verwandelt sich in einen neuen König! Die Verwandlungsregeln hängen vom Modus ab: Instant King oder Kampf um die Krone.",
      q3: "Wie funktioniert Kampf um die Krone?",
      a3: "Nachdem dein König geschlagen wurde, muss dein Herzog zu seiner Startlinie zurückkehren (Reihe 1 für Weiß, Reihe 8 für Schwarz), um sich in einen König zu verwandeln.",
      q4: "Können Herzog-Figuren umgewandelt werden?",
      a4: "Nur in der Wilde-Bauern-Variante! Wenn ein Bauer die letzte Reihe erreicht, kannst du ihn in Dame, Turm, Läufer, Springer oder Herzog umwandeln.",
      q5: "Was ist der Unterschied zwischen Instant King und Kampf um die Krone Skins?",
      a5: "Herzog-Skins gibt es in zwei Versionen: Die 'Instant King'-Version erscheint während des normalen Spiels, während 'Kampf um die Krone' erscheint, wenn dein Herzog kämpft, um die Startlinie zu erreichen."
    },
    multiplayer: {
      q1: "Wie funktioniert Quick Match?",
      a1: "Quick Match paart dich sofort mit einem anderen Spieler! Wähle deinen bevorzugten Spielmodus, klicke auf 'Spiel finden', und du wirst mit jemandem gepaart, der denselben Modus gewählt hat.",
      q2: "Wie erstelle und verwalte ich private Räume?",
      a2: "Gehe zum Tab 'Raum erstellen', gib einen Raumnamen ein, wähle die Spielvariante, stelle Zuschauer-Einstellungen ein und teile den 6-stelligen Code mit Freunden.",
      q3: "Wie trete ich dem Raum eines Freundes bei?",
      a3: "Gehe zum Tab 'Raum beitreten', gib den 6-stelligen Code ein, den dein Freund geteilt hat, und klicke auf 'Beitreten'.",
      q4: "Was sind die Zuschauer-Einstellungen?",
      a4: "Privat: Keine Zuschauer. Beitrittsanfrage: Zuschauer müssen um Genehmigung bitten. Offen: Jeder kann frei zusehen.",
      q5: "Wie schaue ich Spiele als Zuschauer?",
      a5: "Gehe zum Tab 'Zuschauen', um alle öffentlichen Spiele zu sehen. Filtere nach Spieltyp, um bestimmte Varianten zu finden.",
      q6: "Kann ich während der Spiele chatten?",
      a6: "Ja! Während Mehrspieler-Spielen nutze den In-Game-Chat. Nachrichten werden automatisch übersetzt, wenn Spieler verschiedene Sprachen sprechen!",
      q7: "Synchronisiert sich mein Thema mit Gegnern?",
      a7: "Ja! Wenn du der Gastgeber bist, synchronisieren sich dein Brett-Thema, Figuren-Skins und Herzog-Skins automatisch mit allen Spielern."
    },
    customization: {
      q1: "Welche Figuren-Skins sind verfügbar?",
      a1: "Wir haben über 20 Sets: Golden 3D, Obsidian 3D, Vintage, Kawaii, Fabel, Gotik, Kolossal, Amethyst Violett, Saphir Blau, Stein & Sand Königreich, und mehr!",
      q2: "Welche Herzog-Skins sind verfügbar?",
      a2: "Über 50 Herzog-Skins in Kategorien: Metallisch (Gold, Silber), Farbe (Violett, Blau, Smaragd), Weiß (Spartaner, Adler), Schwarz (Stahl, Krone), Edelstein, Königreich, 3D Premium, und mehr!",
      q3: "Wie ändere ich Figuren-Skins?",
      a3: "Einstellungen → Figuren-Skins. Du kannst verschiedene Skins für Weiß und Schwarz separat einstellen! Nutze 'Beide Seiten Vorschau', um zu sehen, wie sie zusammen aussehen.",
      q4: "Wie ändere ich Herzog-Skins?",
      a4: "Einstellungen → Herzog-Skins. Wähle Skins kategorisiert nach Weiß, Schwarz oder Neutral. Jeder Herzog hat sowohl Instant King als auch Kampf um die Krone Varianten.",
      q5: "Was sind Themen-Pakete?",
      a5: "Themen-Pakete bündeln Figuren-Skins, Herzog-Skins und Brett-Themen zusammen! Verfügbare Pakete: Royal Gold, Dark Knight, Vintage Classic und Kingdom Battle Pakete!",
      q6: "Wie bekomme ich ein zufälliges Thema?",
      a6: "Klicke auf 'Zufälliges Themen-Paket' für ein komplettes zufälliges Thema, oder 'Zufälliger Kingdom Battle' für einen zufälligen Fraktions-Kampf.",
      q7: "Kann ich Koordinatenfarben anpassen?",
      a7: "Ja! Einstellungen → Koordinatenfarbe. Wähle eine beliebige Farbe für Reihennummern (1-8) und Spaltenbuchstaben (a-h)."
    },
    boardFeatures: {
      q1: "Was sind die Ansichtsmodi?",
      a1: "Zwei Modi: 3D-Perspektive (mit Tiefe und Schatten) und Draufsicht (flach, traditionell). Wechsle in Einstellungen → Ansichtsmodus.",
      q2: "Wie funktioniert die Brettgrößenanpassung?",
      a2: "Einstellungen → Brettgröße ermöglicht Skalierung von 80% (Kompakt) bis 120% (Groß). Standard ist 100%.",
      q3: "Welche Brett-Themen sind verfügbar?",
      a3: "Mehrere Farbthemen: Klassisches Holz, Royal Gold, Dark Knight, Ozeanblau, Waldgrün, Steingrau und mehr.",
      q4: "Wie funktionieren Koordinaten?",
      a4: "Koordinaten zeigen Reihennummern (1-8) und Spaltenbuchstaben (a-h) an den Bretträndern. Sie drehen sich korrekt mit dem Brett-Drehen-Button!",
      q5: "Funktioniert das Brett auf Mobilgeräten?",
      a5: "Ja! Das Brett ist vollständig responsiv. Im Querformat passt sich das Brett automatisch an die Bildschirmhöhe an."
    },
    skinStore: {
      q1: "Wie greife ich auf den Skin-Shop zu?",
      a1: "Klicke auf den Shop-Button in der Lobby, oder über Einstellungen → 'Shop besuchen'. Der Shop hat drei Tabs: Themen-Sets, Figuren-Skins und Herzog-Skins.",
      q2: "Was sind Themen-Sets?",
      a2: "Komplette Themenpakete mit Rabatt! Sie enthalten passende Figuren-Skins, Herzog-Skins und Brett-Themen.",
      q3: "Gibt es Paket-Rabatte?",
      a3: "Ja! 'Alle Figuren-Skins Paket' und 'Alle Herzog-Skins Paket' geben dir alle Skins mit 40% Rabatt.",
      q4: "Wie funktionieren Skin-Seltenheiten?",
      a4: "Gewöhnlich (grau): Kostenlos oder Basis. Selten (blau): 1,99-2,49€. Episch (violett): 2,49-3,99€. Legendär (gold): 3,49-4,99€.",
      q5: "Kann ich Skins vor dem Kauf ansehen?",
      a5: "Ja! Fahre über eine Skin-Karte für eine Vorschau. Figuren-Skins zeigen König, Dame und Springer.",
      q6: "Wie rüste ich gekaufte Skins aus?",
      a6: "Im Shop zeigen besessene Skins 'Ausrüsten' statt Preis. Klicke auf Ausrüsten zum sofortigen Anwenden."
    },
    trialPayments: {
      q1: "Was ist die 48-Stunden-Testversion?",
      a1: "Neue Benutzer erhalten 48 Stunden kostenlosen Zugang zu ALLEN Varianten. Nach der Testversion bleiben Standard-Schach und Instant King kostenlos.",
      q2: "Wie viel kosten die Varianten?",
      a2: "Kampf um die Krone & Handicap-Modus: 2,99€, Spielerwahl: 3,99€, Wilde Bauern & Zwei Herzöge: 4,99€. Oder hole das Alle-Varianten-Paket für 8,99€!",
      q3: "Wie viel kosten Skins?",
      a3: "Einzelne Skins: 1,99-4,99€ je nach Seltenheit. Pakete: ~40% Rabatt. Themen-Sets: 8,99-12,99€.",
      q4: "Kann ich als Gast spielen?",
      a4: "Ja! Der Gastmodus ermöglicht sofortiges Spielen ohne Anmeldung. Jedoch wird der Spielverlauf nicht gespeichert.",
      q5: "Wie funktionieren Zahlungen?",
      a5: "Alle Zahlungen werden sicher über Stripe verarbeitet. Einmalkäufe schalten Inhalte für immer frei. Keine Abonnements erforderlich."
    },
    strategyTips: {
      q1: "Herzog-Eröffnungsstrategie?",
      a1: "Positioniere deinen Herzog früh zur Kontrolle der zentralen Diagonalen. Seine einzigartige 8-Richtungen-Schlagfähigkeit macht ihn hervorragend zum Bedrohen mehrerer Figuren.",
      q2: "Wann Instant King vs Kampf um die Krone wählen?",
      a2: "Wähle Instant King, wenn dein Herzog gut positioniert ist. Wähle Kampf um die Krone, wenn dein Herzog bereits nahe der Startlinie ist.",
      q3: "Zwei-Herzöge-Variante Strategie?",
      a3: "Schütze beide Herzöge sorgfältig - sie sind deine 'Extra-Leben'! Wenn dein König geschlagen wird, wähle den sichereren Herzog für die Verwandlung.",
      q4: "Wilde-Bauern-Endspiel?",
      a4: "Erwäge Bauern zu Herzögen umzuwandeln als 'König-Versicherung' - wenn dein König später geschlagen wird, kann ein umgewandelter Herzog dein neuer König werden!",
      q5: "Brett-Drehen strategisch nutzen?",
      a5: "Drehe das Brett, um Positionen aus der Perspektive deines Gegners zu sehen! Das hilft, Bedrohungen zu erkennen, die du übersehen könntest."
    },
    troubleshooting: {
      q1: "Spiel lädt langsam",
      a1: "Versuche den Fehlerbehebungs-Button für Diagnosen. Überprüfe deine Internetverbindung. Versuche die Seite zu aktualisieren (Strg+F5).",
      q2: "Mehrspieler verbindet nicht",
      a2: "Nutze die Fehlerbehebung, um den WebSocket-Verbindungsstatus zu prüfen. Stelle sicher, dass du eingeloggt bist. Überprüfe Firewall/VPN-Probleme.",
      q3: "Einstellungen speichern nicht",
      a3: "Einstellungen nutzen localStorage. Prüfe, ob dein Browser es erlaubt. Versuche die 'Einstellungen zurücksetzen'-Option in der Fehlerbehebung.",
      q4: "Wo ist der Zugverlauf?",
      a4: "Die Zugverlauf-Seitenleiste erscheint auf der RECHTEN Seite während aktiver Spiele. Erfordert Browserbreite > 768px.",
      q5: "Brettgrößen-Schieberegler funktioniert nicht?",
      a5: "Versuche: 1) Seite aktualisieren. 2) Browser-Cache leeren. 3) Prüfen, ob du in einem Spiel bist. 4) Anderen Ansichtsmodus versuchen.",
      q6: "Figuren sehen zu klein/groß aus?",
      a6: "Verschiedene Figuren-Skins haben unterschiedliche optimale Größen. Gehe zu Einstellungen → Brettgröße zum Anpassen.",
      q7: "Passwort vergessen?",
      a7: "Gehe zur Konto-Seite → 'Passwort vergessen?' → Beantworte deine Sicherheitsfragen → Passwort wird an deine E-Mail gesendet.",
      q8: "Wie kontaktiere ich den Support?",
      a8: "Nutze die Fehlerbehebung für technische Probleme. Für Abrechnungs-/Kontoprobleme sende eine E-Mail von der Konto-Seite."
    },
    tips: {
      tip1: "Der Herzog kann in 8 Richtungen schlagen, bewegt sich aber nur diagonal, wenn er nicht schlägt!",
      tip2: "Im Kampf um die Krone Modus muss dein Herzog die Startlinie erreichen, um sich zu verwandeln.",
      tip3: "Positioniere deinen Herzog zur Kontrolle mehrerer Felder - seine einzigartige Bewegung ist mächtig!",
      tip4: "In der Zwei-Herzöge-Variante gibt dir das Schützen beider Herzöge mehr Comeback-Optionen.",
      tip5: "In Wilde Bauern gibt dir die Umwandlung zum Herzog 'König-Versicherung', falls geschlagen.",
      tip6: "Quick Match: Wähle denselben Spielmodus wie dein Gegner für sofortige Paarung!",
      tip7: "Erstellte Räume erscheinen unter 'Meine Räume', beigetretene unter 'Beigetretene Räume'.",
      tip8: "Setze deinen Raum auf 'Offen', damit jeder deine epischen Spiele sehen kann!",
      tip9: "Anfragemodus: Spieler müssen Zuschauer genehmigen - perfekt für private Lektionen.",
      tip10: "Du kannst maximal 5 Räume erstellen. Beende oder schließe sie für mehr.",
      tip11: "Klicke auf Einstellungen, um Brett- und Figurenfarben jederzeit zu ändern.",
      tip12: "Alle deine Züge werden in der Seitenleiste rechts aufgezeichnet.",
      tip13: "Nachrichten werden automatisch übersetzt für Spieler mit verschiedenen Sprachen!",
      tip14: "Jeder private Raum erhält einen einzigartigen 6-stelligen Code zum Teilen mit Freunden.",
      tip15: "Themen-Pakete: Erhalte passende Figuren, Herzöge und Brett-Themen mit einem Klick!",
      tip16: "Probiere Stein & Sand vs Waldkrieger für epische Fraktionskriege!",
      tip17: "Lass das Spiel ein zufälliges Thema wählen - entdecke neue Favoriten!",
      tip18: "Amethyst Violett und Saphir Blau lassen deine Figuren strahlen!",
      tip19: "Klicke auf den Drehen-Button für die Schwarz-Perspektive - super für Analyse!",
      tip20: "Drehe dein Gerät für eine größere Brettansicht auf Mobilgeräten!",
      tip21: "Nutze den Schieberegler in Einstellungen, um das Brett von 80% bis 120% zu skalieren!",
      tip22: "Die Kolossal-Sets zeigen epische Marmor- und Bronze-Skulpturen!",
      tip23: "Vier süße Kawaii-Emoji-Figurensets - Braun, Weiß, Schwarz und Beige!",
      tip24: "Die Gotik Weiß und Schwarz Sets zeigen aufwendige Dark-Fantasy-Designs!",
      tip25: "Fabel Mittelalter: Kreuzritter vs dunkle Krieger - epische Kampffiguren!"
    }
  },

  // Account Manager
  account: {
    title: "Kontoverwaltung",
    accountInfo: "Kontoinformationen",
    usernameEmail: "Benutzername/E-Mail",
    displayName: "Anzeigename",
    accountType: "Kontotyp",
    userId: "Benutzer-ID",
    guest: "Gast",
    registered: "Registriert",
    notAvailable: "N/V",
    notificationSettings: "Benachrichtigungseinstellungen",
    notificationSound: "Benachrichtigungston",
    notificationSoundDesc: "Ton abspielen bei Benachrichtigungen",
    security: "Sicherheit",
    passwordManagement: "Passwortverwaltung",
    passwordNote: "Aus Sicherheitsgründen zeigen wir keine Passwörter an. Wenn du dein Passwort zurücksetzen musst, nutze die 'Passwort vergessen'-Funktion.",
    forgotPassword: "Passwort vergessen?",
    passwordRecovery: "Passwort-Wiederherstellung",
    passwordRecoveryHelp: "Beantworte deine Sicherheitsfragen, um dein Passwort per E-Mail zu erhalten",
    securityQuestion1: "Sicherheitsfrage 1",
    securityQuestion2: "Sicherheitsfrage 2",
    selectQuestion: "Frage auswählen...",
    yourAnswer: "Deine Antwort",
    sendPasswordEmail: "Passwort per E-Mail senden",
    securityQuestions: {
      q1: "Wie hieß dein erstes Haustier?",
      q2: "In welcher Stadt wurdest du geboren?",
      q3: "Wie ist der Mädchenname deiner Mutter?",
      q4: "Wie hieß deine Grundschule?",
      q5: "Was ist dein Lieblingsbuch?",
      q6: "Was war dein Spitzname als Kind?",
      q7: "Wie heißt dein Lieblingslehrer?",
      q8: "In welcher Straße bist du aufgewachsen?"
    },
    dangerZone: "Gefahrenzone",
    deleteAccount: "Konto löschen",
    deleteAccountDesc: "Dein Konto und alle zugehörigen Daten dauerhaft löschen.",
    deleteWarning: "Dies wird dauerhaft gelöscht:",
    deleteWarningItems: {
      account: "Dein Konto und Profil",
      gameHistory: "Gesamter Spielverlauf",
      friends: "Freundesverbindungen",
      purchases: "Gekaufte Varianten",
      settings: "Einstellungen und Präferenzen"
    },
    typeDelete: "Tippe DELETE zum Bestätigen:",
    typeDeletePlaceholder: "Tippe DELETE hier",
    deleteForever: "Mein Konto für immer löschen",
    deleteConfirmMsg: "Diese Aktion kann nicht rückgängig gemacht werden.",
    deleteSuccess: "Konto erfolgreich gelöscht. Du wirst ausgeloggt.",
    deleteFailed: "Konto konnte nicht gelöscht werden",
    passwordResetSuccess: "Passwort-Reset erfolgreich! Dein Passwort wurde an deine E-Mail-Adresse gesendet. Prüfe deinen Posteingang (und Spam-Ordner).",
    securityAnswersIncorrect: "Sicherheitsantworten falsch. Bitte versuche es erneut.",
    passwordResetFailed: "Passwort-Reset fehlgeschlagen. Bitte versuche es erneut.",
    answerBothQuestions: "Bitte beantworte beide Sicherheitsfragen"
  }
};

export default de;
